export default {
  install(app) {
    app.config.globalProperties.$numFormat = (key) => {
      return Number(key).toLocaleString().replace(",", ".");
    };
  },
};
